<ion-icon [name]="icon" (click)="createTooltip($event)" [color]="color" [size]="size" [style]="styles"></ion-icon>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
